module.exports = __webpack_public_path__ + "static/img/2.abef40a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2.jpg
// module id = 290
// module chunks = 0